module.exports = __webpack_public_path__ + "img/detail-1.6e58de07.png";